module.exports = __webpack_public_path__ + "static/img/20260605_3.8ff7b26.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/20260605_3.jpg
// module id = 3JcD
// module chunks = 98